import { Box } from "@mui/material";

interface AppLayoutInnerWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper for the inner content of the app layout
 * Renders below the header and wraps navigation menu and page content
 */
export function AppLayoutInnerWrapper(props: AppLayoutInnerWrapperProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0,
        flex: 1,
        minHeight: 0, // Allow flex child to shrink below content size
      }}
    >
      {children}
    </Box>
  );
}
